import React, { Component } from 'react';
import PropTypes from 'prop-types';
import activeBellSvg from '../../../images/bell-active.svg';
import inactiveBellSvg from '../../../images/bell-inactive.svg';
import './CheckBox.css';

class LabeledBellCheckBox extends Component {
  static propTypes = {
    checked: PropTypes.bool,
    className: PropTypes.string,
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    readOnly: PropTypes.bool,
    size: PropTypes.oneOf(['small', 'medium']),
    color: PropTypes.string,
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    onChange: PropTypes.func,
  };

  static defaultProps = {
    className: null,
    readOnly: false,
    size: 'medium',
    color: null,
    label: null,
    onChange: () => {},
  };

  handleSelectChange = (event) => {
    event.preventDefault();
    event.stopPropagation();

    if (!this.props.readOnly) {
      this.props.onChange(!this.props.checked);
    }
  };

  static getImage(checked, readOnly) {
    let image;
    if (checked) {
      if (!readOnly) {
        image = activeBellSvg;
      } else {
        image = activeBellSvg;
      }
    } else {
      image = inactiveBellSvg;
    }

    return image;
  }

  render() {
    return (
      <div className="labeled-bell-checkbox">
        <div
          className={
            'checkbox-container size-' +
            this.props.size +
            (this.props.className !== null ? ' ' + this.props.className : '')
          }
          onClick={this.handleSelectChange}
        >
          <img
            className={
              'box-img size-' +
              this.props.size +
              (this.props.readOnly ? ' read-only' : '') +
              (!this.props.checked ? ' empty' : '')
            }
            src={LabeledBellCheckBox.getImage(
              this.props.checked,
              this.props.readOnly
            )}
            alt="plus"
          />
        </div>

        <div className="checkbox-label">
          {this.props.label} {this.props.checked ? 'On' : 'Off'}
        </div>
      </div>
    );
  }
}

export default LabeledBellCheckBox;



// WEBPACK FOOTER //
// ./src/components/shared/checkbox/LabeledBellCheckBox.js